import React, { useState } from "react";
import FloatingInput from "../common/FloatingInput";

function ServiceStatuses(props) {
  const [config, setConfig] = useState({
    statuses: [
      "Attended",
      "Attended w Direct Supervision",
      "Bed Hold",
      "Call Answered",
      "Call Left Voicemail",
      "Cancelled by Client",
      "Cancelled by Provider",
      "Completed",
      "Discharged",
      "Double Paid Respite",
      "Group",
      "No Show",
      "Normalcy Visit",
      "NV",
      "Occupied",
      "Paid Leave",
      "Pass Through",
      "Placement Pending",
      "Respite",
      "Substitute",
      "Team",
      "Unpaid Leave",
      "Unpaid Respite",
      "With Child",
      "Without Child",
    ],
    types: ["Census", "MentalHealth", "Billing", "YouthAllowance"],
    matrix: {
      Census: [
        "Occupied",
        "Discharged",
        "Respite",
        "Double Paid Respite",
        "Unpaid Respite",
        "Paid Leave",
        "Unpaid Leave",
      ],
      MentalHealth: [
        "Attended",
        "Attended w Direct Supervision",
        "Call Answered",
        "Call Left Voicemail",
        "Cancelled by Client",
        "Cancelled by Provider",
        "Group",
        "No Show",
        "Normalcy Visit",
        "Team",
      ],
      Billing: [],
      YouthAllowance: [],
    },
  });
  const [addNewOpen, setAddNewOpen] = useState(false);
  const [addTypeOpen, setAddTypeOpen] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [newType, setNewType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  const addNewStatus = () => {
    const obj = { ...config };
    obj.statuses.push(newStatus);
    setConfig(obj);
    setAddNewOpen(false);
    setNewStatus("");
  };

  const addNewType = () => {
    const obj = { ...config };
    obj.types.push(newType);
    obj.matrix[newType] = [];
    setConfig(obj);
    setAddTypeOpen(false);
    setNewType("");
  };

  const addToType = (type) => {
    const obj = { ...config };
    if (!obj.matrix[type].includes(selectedStatus)) {
      obj.matrix[type].push(selectedStatus);
    }
    setConfig(obj);
  };

  const repositionStatus = (type, status, direction) => {
    const obj = { ...config };
    const index = obj.matrix[type].indexOf(status);
    if (direction === "up") {
      if (index > 0) {
        obj.matrix[type].splice(
          index - 1,
          0,
          obj.matrix[type].splice(index, 1)[0]
        );
      }
    } else {
      if (index < obj.matrix[type].length - 1) {
        obj.matrix[type].splice(
          index + 1,
          0,
          obj.matrix[type].splice(index, 1)[0]
        );
      }
    }
    setConfig(obj);
  };

  return (
    <>
      <div className="h4">Service Statuses</div>
      <div className="rounded border bg-info p-2">
        <div className="h5">
          Available Statuses
          <i
            className="fas fa-plus-circle ms-2"
            role="button"
            onClick={() => setAddNewOpen(true)}
          />
        </div>
        {addNewOpen === true && (
          <div className="row mb-2">
            <div className="col-11">
              <FloatingInput
                name="newStatus"
                label="New Status"
                value={newStatus}
                onChange={({ currentTarget: input }) =>
                  setNewStatus(input.value)
                }
              />
            </div>
            <div className="col">
              <div
                className="btn btn-success mt-4"
                onClick={() => addNewStatus()}
              >
                Save
              </div>
            </div>
          </div>
        )}
        {config.statuses.map((status) => (
          <div
            key={status}
            className={`btn btn-sm border border-dark m-1 ${
              status === selectedStatus ? "btn-success" : "btn-light"
            }`}
            onClick={() => setSelectedStatus(status)}
          >
            {status}
          </div>
        ))}
      </div>
      <div className="rounded border bg-light p-2 my-2">
        <div className="h5">
          Types
          <i
            className="fas fa-plus-circle ms-2"
            role="button"
            onClick={() => setAddTypeOpen(true)}
          />
        </div>
        {addTypeOpen === true && (
          <div className="row mb-2">
            <div className="col-11">
              <FloatingInput
                name="newType"
                label="New Type"
                value={newType}
                onChange={({ currentTarget: input }) => setNewType(input.value)}
              />
            </div>
            <div className="col">
              <div
                className="btn btn-success mt-4"
                onClick={() => addNewType()}
              >
                Save
              </div>
            </div>
          </div>
        )}
        {config?.types &&
          config.types.map((type) => (
            <div
              key={type}
              className="rounded border border-dark bg-safy2-1 text-white m-1 p-2"
            >
              <div className="row">
                <div className="col-2">
                  <div className="h5">{type}</div>
                  {selectedStatus !== "" && (
                    <div
                      className="btn btn-sm btn-light w-100"
                      onClick={() => addToType(type)}
                    >
                      {`Add to ${type}`}
                    </div>
                  )}
                </div>
                <div className="col-10">
                  <div className="rounded border border-dark bg-white text-dark h-100">
                    {config?.matrix[type] &&
                      config.matrix[type].map((s, index) => (
                        <div
                          key={`${type}${s}${index}`}
                          className="d-inline-flex btn btn-sm btn-secondary m-1 p-1"
                        >
                          {index > 0 && (
                            <i
                              className="fas fa-arrow-left text-info m-1"
                              role="button"
                              onClick={() => repositionStatus(type, s, "up")}
                            />
                          )}
                          <div className="mx-1">{s}</div>
                          {index < config.matrix[type].length - 1 && (
                            <i
                              className="fas fa-arrow-right text-info m-1"
                              role="button"
                              onClick={() => repositionStatus(type, s, "down")}
                            />
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="btn btn-success">SAVE TO DATABASE</div>
    </>
  );
}

export default ServiceStatuses;
